import { render, staticRenderFns } from "./NavDesktopApp.vue?vue&type=template&id=36d90e37&scoped=true&"
import script from "./NavDesktopApp.vue?vue&type=script&lang=js&"
export * from "./NavDesktopApp.vue?vue&type=script&lang=js&"
import style0 from "./NavDesktopApp.vue?vue&type=style&index=0&id=36d90e37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d90e37",
  null
  
)

export default component.exports